module.exports = __webpack_public_path__ + "assets/img/member-list.f88fe09a.svg";